import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SessionStorageService } from '@shared/services';

@Component({
  selector: 'application-switcher-mobile',
  templateUrl: './application-switcher-mobile.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ApplicationSwitcherMobileComponent {
  private readonly COMPONENT_NAME: string = 'ApplicationSwitcherMobile';

  constructor(
    private sessionStorageService: SessionStorageService
  ) {}

  close(e = null): void {
    if (!e || !e.target.closest('.application-switcher-modal')) this.sessionStorageService.popDynamicComponent(this.COMPONENT_NAME);
  }

}
